import React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

import { bemBlock } from '../../modules/bem';
import { ScrollArea } from '../scroll-area/ScrollArea';

import { ActionsMenuSeparator as Separator } from './ActionsMenuSeparator';

import './ActionsMenuContent.less';

const block = bemBlock('n-actions-menu-content');

type ContentOwnProps = {
  header?: React.ReactNode;
  footer?: React.ReactNode;
};

type ContentProps = React.ComponentPropsWithoutRef<typeof DropdownMenu.Content> & ContentOwnProps;

export const ActionsMenuContent = React.forwardRef<
  React.ElementRef<typeof DropdownMenu.Content>,
  ContentProps
>(function ActionsMenuContent({ className, children, header, footer, ...props }, ref) {
  return (
    <DropdownMenu.Content
      ref={ref}
      className={block({
        extra: className,
      })}
      {...props}
    >
      {header && (
        <>
          <div className={block('header')}>{header}</div>
          <Separator />
        </>
      )}
      <ScrollArea className={block('scroll-area')}>
        <ScrollArea.Viewport className={block('scroll-area-viewport')}>
          {children}
        </ScrollArea.Viewport>
        <ScrollArea.Scrollbar orientation="vertical" />
        <ScrollArea.Scrollbar orientation="horizontal" />
        <ScrollArea.Corner />
      </ScrollArea>
      {footer && (
        <>
          <Separator />
          {footer}
        </>
      )}
    </DropdownMenu.Content>
  );
});
